var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 56.5C13.0356 56.5 0.5 43.9644 0.5 28.5C0.5 13.0356 13.0356 0.5 28.5 0.5C43.9644 0.5 56.5 13.0356 56.5 28.5C56.5 43.9644 43.9644 56.5 28.5 56.5ZM28.5 53.14C35.0349 53.14 41.3022 50.544 45.9231 45.9231C50.544 41.3022 53.14 35.0349 53.14 28.5C53.14 21.9651 50.544 15.6978 45.9231 11.0769C41.3022 6.45599 35.0349 3.86 28.5 3.86C21.9651 3.86 15.6978 6.45599 11.0769 11.0769C6.45599 15.6978 3.86 21.9651 3.86 28.5C3.86 35.0349 6.45599 41.3022 11.0769 45.9231C15.6978 50.544 21.9651 53.14 28.5 53.14ZM25.2184 35.6624L41.4836 19.4L43.858 21.7772L27.198 38.4372C26.6729 38.9621 25.9609 39.257 25.2184 39.257C24.4759 39.257 23.7639 38.9621 23.2388 38.4372L14.5 29.6928L16.8772 27.3156L25.2212 35.6596L25.2184 35.6624Z",
    fill: "#41AD6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.5eac97cb144d33cbaaee530bc89bf816.svg";
export { ForwardRef as ReactComponent };